export const ARIA_PATH = '/home/aria';
export const ARIA_THREAD_PATH = `${ARIA_PATH}/threads/:threadId`;
export const ARIA_PATHS = [ARIA_PATH, ARIA_THREAD_PATH];

export const ariaThreadPath = (threadId: string) =>
  `${ARIA_PATH}/threads/${encodeURIComponent(threadId)}`;

/**
 * Whether a pathname is the full-page ARIA route. Headers use this to decide
 * whether to render the drawer or just a disabled "Ask ARIA" button, since the
 * page owns the chat runtime on that route.
 */
export const isAriaPagePath = (pathname: string): boolean => {
  const normalizedPath = pathname.replace(/\/+$/, '');
  return (
    normalizedPath === ARIA_PATH ||
    normalizedPath.startsWith(`${ARIA_PATH}/threads/`)
  );
};
